import { defineComponent, computed } from '@vue/composition-api';
import { MessageVariant, MessageFontStyle, MessageTheme } from './constants.js';

/**
 * @deprecated Use SdsAlert instead
 */
var script = defineComponent({
    name: 'SbNotificationMessage',
    props: {
        theme: {
            type: String,
            required: true,
        },
        variant: {
            type: String,
            required: false,
            default: MessageVariant.Block,
        },
        fontStyle: {
            type: String,
            required: false,
            default: MessageFontStyle.Regular,
        },
    },
    setup: function (props) {
        var isInfo = computed(function () { return props.theme === MessageTheme.Info || props.theme === MessageTheme.InfoLayer1 || props.theme === MessageTheme.InfoLayer2 || props.theme === MessageTheme.AlertInfo; });
        return {
            MessageTheme: MessageTheme,
            isInfo: isInfo,
        };
    },
});

export default script;
